<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count='count'
      :current="page"
    >
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem" v-if="roleType!==2">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>
            <!-- <label>商品:</label>
            <lk-input clearable v-model='query.nameMix' class="item" placeholder="商品名称、通用名称、助记码、商品编码"></lk-input> -->
          </div>
          <div class="queryItem">
            <label>商品类型:</label>
            <lk-select v-model='query.goodsType' class="item" clearable>
              <lk-option v-for="(item, index) in getNormalGoodsTypes" :key="index" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>来源:</label>
            <lk-select v-model='query.purchaseType' class="item" clearable>
              <lk-option v-for="(item, index) in getGoodsOrigin" :key="index" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>规格:</label>
            <lk-input clearable v-model='query.spec' class="item" placeholder="请输入"></lk-input>
          </div>
          <!-- <div class="queryItem">
            <label>单位:</label>
            <lk-input clearable v-model='query.goodsSerialCode' class="item" placeholder="请输入"></lk-input>
          </div>
          <div class="queryItem">
            <label>产地:</label>
            <lk-input clearable v-model='query.goodsSerialCode' class="item" placeholder="请输入"></lk-input>
          </div>  -->
          <div class="queryItem">
            <label>生产企业:</label>
            <lk-input clearable v-model='query.producer' class="item" placeholder="请输入"></lk-input>
          </div>
          <div class="queryItem">
            <label>批准文号/注册证号:</label>
            <lk-input clearable v-model='query.approvalCode' class="item" placeholder="请输入"></lk-input>
          </div>
          <div class="queryItem">
            <label>单号:</label>
            <lk-input clearable v-model='query.orderCode' class="item" placeholder="请输入"></lk-input>
          </div>
          <div class="queryItem">
            <label>创建时间:</label>
            <timeStampDatePicker  v-model='query.createTimeStart' class="item"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>至</label>
            <timeStampDatePicker  v-model='query.createTimeEnd' class="item"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>是否DTP:</label>
            <lk-select v-model='query.isDtp' class="item">
              <lk-option v-for="(item, index) in isDtpList" :key="index" :value="index + 1">{{item}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>储存条件:</label>
            <lk-select v-model='query.storageCondition' class="item">
              <lk-option v-for="(item, index) in storageConditionsList" :key="index" :value="item.dictionaryIndex">{{item.dictionaryName}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>GSP分类:</label>
            <lk-select v-model='query.gspIdList' class="item" filterable multiple>
              <lk-option v-for="(item, index) in gspList" :key="index" :value="item.id">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="mb8">
          <DownloadButton v-if="handlePermission('orderStatsDownloadBtn')" @on-click="handleExport"></DownloadButton>
        </div>
        <div class="Report-total-container">
          <div class="Report-total-title">合计</div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">采购数量:</div>
            <div class="Report-total-item-value">{{total.allNumDisplay}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">总金额:</div>
            <div class="Report-total-item-value">{{total.allAmountDisplay}}</div>
          </div>
        </div>
        <lk-table border :columns='columns' :data='tableData'></lk-table>
      </div>
    </QueryFrame>

  </div>
</template>
<script>

import { mapGetters } from 'vuex';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import purchase from '../../services/purchase';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import goodsService from '../../services/goods';

import DownloadButton from '../../components/download/DownloadButton.vue';

export default {
  name: 'orderStats',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame, DownloadButton,
  },
  computed: {
    // getNormalGoodsTypes() {
    //   return this.$store.state.publicParams.goodsTypes;
    // },
    ...mapGetters(['getNormalGoodsTypes', 'getGoodsOrigin']),
  },
  data() {
    return {
      storageConditionsList: [],
      isDtpList: ['是', '否'],
      gspList: [],
      query: {
        storeIdList: [],
        spec: '',
        producer: '',
        approvalCode: '',
        createTimeStart: null,
        createTimeEnd: null,
        orderCode: '',
        nameMix: '',
        goodsType: '',
        purchaseType: 1,
      },
      columns: [
        {
          title: '门店名称',
          key: 'purchaseOrderStoreName',
          tooltip: true,
          minWidth: 142,
        },
        {
          title: '业务日期',
          key: 'purchaseOrderCreateTime',
          tooltip: true,
          minWidth: 144,
        },
        {
          title: '采购单号',
          key: 'purchaseOrderCode',
          tooltip: true,
          minWidth: 172,
        },
        {
          title: '计划单号',
          key: 'purchasePlanCode',
          tooltip: true,
          minWidth: 172,
        },
        {
          title: '商品类型',
          key: 'purchaseMedicineGoodsTypeName',
          tooltip: true,
          minWidth: 82,
        },
        {
          title: '来源',
          key: 'purchaseMedicinePurchaseTypeName',
          tooltip: true,
          minWidth: 82,
        },
        {
          title: '状态',
          key: 'purchaseOrderStatusName',
          tooltip: true,
          minWidth: 96,
        },
        {
          title: '商品编码',
          key: 'purchaseMedicineDrugSerialCode',
          tooltip: true,
          minWidth: 82,
        },
        {
          title: '通用名称',
          key: 'medicineInfoVoApprovedDrugNames',
          tooltip: true,
          minWidth: 142,
        },
        {
          title: '商品名称',
          key: 'medicineInfoVoGoodsName',
          tooltip: true,
          minWidth: 142,
        },
        {
          title: '规格',
          key: 'medicineInfoVoSpecifications',
          tooltip: true,
          minWidth: 130,
        },
        {
          title: '批准文号/注册证号',
          key: 'medicineInfoVoApprovalCode',
          tooltip: true,
          minWidth: 134,
        },
        {
          title: '储存条件',
          key: 'medicineInfoVoStorageConditions',
          tooltip: true,
          minWidth: 112,
        },
        {
          title: '是否DTP',
          key: 'purchaseMedicineIsDtpName',
          tooltip: true,
          minWidth: 82,
        },
        {
          title: 'GSP分类',
          key: 'medicineInfoVoGspLabelNames',
          tooltip: true,
          minWidth: 142,
        },
        {
          title: '生产厂家',
          key: 'medicineInfoVoManufacturer',
          tooltip: true,
          minWidth: 142,
        },
        {
          title: '采购数量',
          key: 'purchaseMedicineNum',
          tooltip: true,
          minWidth: 86,
        },
        {
          title: '包装单位',
          key: 'medicineInfoVoDrugMinimumPackagingUnitString',
          tooltip: true,
          minWidth: 86,
        },
        {
          title: '计划单价',
          key: 'purchaseMedicinePlanPrice',
          tooltip: true,
          minWidth: 86,
        },
        {
          title: '总金额',
          key: 'purchaseMedicineAmount',
          tooltip: true,
          minWidth: 94,
        },
        {
          title: '供应商名称',
          key: 'purchaseMedicineSupplierName',
          tooltip: true,
          minWidth: 142,
        },
        {
          title: '成本类型',
          key: 'purchaseMedicinePaymentName',
          tooltip: true,
          minWidth: 82,
        },
      ],
      tableData: [],
      total: {},
    };
  },
  methods: {
    getTotal() {
      const params = Object.assign({}, this.query);
      // if (params.createTimeStart) {
      //   params.createTimeStart = (new Date(params.createTimeStart)).getTime();
      // }
      // if (params.createTimeEnd) {
      //   params.createTimeEnd = (new Date(params.createTimeEnd)).getTime();
      // }
      purchase.getOrderStatsSummary(params).then((res) => {
        if (res.data.status === 200) {
          this.total = res.data.data;
        }
      });
    },
    clear() {
      this.query = {
        storeIdList: [],
        gspIdList: [],
      };
    },
    handleExport() {
      const params = Object.assign({}, this.query);
      // if (params.createTimeStart) {
      //   params.createTimeStart = (new Date(params.createTimeStart)).getTime();
      // }
      // if (params.createTimeEnd) {
      //   params.createTimeEnd = (new Date(params.createTimeEnd)).getTime();
      // }
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      purchase.orderStatsDownload(params)
        .then((res) => {
          if (res.data.error) {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getGSPList() {
      goodsService.listGoodsLabels({ categoryId: 1 }).then((res) => {
        if (res.data.status === 200) {
          this.gspList = res.data.data.list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getStorageConditionsList() {
      goodsService.GoodsDictionary({ dictionaryTypeEnum: 9 }).then((res) => {
        if (res.data.status === 200) {
          this.storageConditionsList = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getData() {
      const params = Object.assign({}, this.query);
      params.page = this.page;
      params.size = this.size;
      // if (params.createTimeStart) {
      //   params.createTimeStart = (new Date(params.createTimeStart)).getTime();
      // }
      // if (params.createTimeEnd) {
      //   params.createTimeEnd = (new Date(params.createTimeEnd)).getTime();
      // }
      this.getTotal();
      purchase.orderStats(params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.purchaseOrderCreateTime = utils.formatDate(result.purchaseOrderCreateTime);
            console.log(result);
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.getGSPList();
    this.getStorageConditionsList();
    this.handleSearch(true);
  },
};
</script>
